























































































































































































import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
    ...mapGetters(["account"]),
    components: {},
})
export default class ReportStatus extends Vue {
    @Prop({ type: Object })
    records!: any;

    @Prop({ type: Number })
    flowType!: number;

    flowName: string = this.flowType === 1 ? "电子税务局" : "自然人扣缴";
    recordsCopy: any = [];

    mounted() {
        if (this.records) {
            this.recordsCopy = this.records;
        }
    }

    clientList: any[] = [
        {
            id: 0,
            no: "----",
            name: "增值税一般纳税人月度申报",
            type: "完成申报",
            payType: "无需扣款",
            taxPrice: "1,520.35",
        },
        {
            id: 1,
            no: "----",
            name: "城建税、教育费附加、地方教育费附加税（费）申报表",
            type: "完成申报",
            payType: "无需扣款",
            taxPrice: "1,520.35",
        },
        {
            id: 2,
            no: "----",
            name: "财务报表月(季)申报(适用执行小企业会计准则的企业)",
            type: "完成申报",
            payType: "无需扣款",
            taxPrice: "1,520.35",
        },
    ];
    chargeList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 0,
        },
        {
            text: "未申报",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "申报中",
            id: 3,
        },
        {
            text: "完成申报",
            id: 4,
        },
        {
            text: "申报异常",
            id: 5,
        },
        {
            text: "无需申报",
            id: 6,
        },
    ];
    accountList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 0,
        },
        {
            text: "未扣款",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "扣款中",
            id: 3,
        },
        {
            text: "完成扣款",
            id: 4,
        },
        {
            text: "扣款异常",
            id: 5,
        },
        {
            text: "无需扣款",
            id: 6,
        },
    ];
    taxTypeList: DataTable.DropItem[] = [
        {
            text: "增值税申报",
            id: 1,
        },
        {
            text: "个税申报",
            id: 2,
        },
        {
            text: "财务报表申报",
            id: 3,
        },
        {
            text: "其他税种申报",
            id: 4,
        },
    ];
    getStatus(type: number, code: number) {
        if (type === 0) {
            for (let i = 0; i < this.chargeList.length; i++) {
                if (this.chargeList[i].id === code) return this.chargeList[i];
            }
        } else if (type === 1) {
            for (let i = 0; i < this.accountList.length; i++) {
                if (this.accountList[i].id === code) return this.accountList[i];
            }
        } else {
            for (let i = 0; i < this.taxTypeList.length; i++) {
                if (this.taxTypeList[i].id === code) return this.taxTypeList[i];
            }
        }
    }
    downLoad(data: any) {
        if (data.resultUrl) {
            let url = data.resultUrl;
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", url);
        }
    }
    // 查看详情
    errContent(msg: string) {
        if (msg) {
            this.$message.warning(msg);
        }
    }
    delRow(data: any) {
        Vue.axios.post(`tax/record/delete`, data).then((res) => {
            for (let i = 0; i < this.recordsCopy.records.length; i++) {
                if (this.recordsCopy.records[i].id === data.id) {
                    this.recordsCopy.records.splice(i, 1);
                }
            }
        });
    }
    change(data: any) {
        Vue.axios.post(`tax/record/resave`, data).then((res) => {
            for (let i = 0; i < this.recordsCopy.records.length; i++) {
                if (this.recordsCopy.records[i].id === data.id) {
                    this.recordsCopy.records[i].resultUrl = res.data.resultUrl;
                    this.recordsCopy.records[i].resultMessage =
                        res.data.resultMessage;
                    this.recordsCopy.records[i].taxState = res.data.taxState;
                    this.recordsCopy.records[i].taxTypeStr =
                        res.data.taxTypeStr;
                }
            }
        });
    }
    // 查看图片
    showImg: boolean = false;
    imgSrc: string = "";
    imgList: string[] = [];
    changeImg(img: string) {
        this.imgSrc = img;
        this.imgList = [img];
        this.showImg = true;
    }
    imgWidth: number = 100;
    imgHeight: number = 100;
    plus() {
        if (this.imgWidth < 160) {
            this.imgWidth = this.imgWidth + 10;
        }
        if (this.imgHeight < 160) {
            this.imgHeight = this.imgHeight + 10;
        }
    }
    cut() {
        if (this.imgWidth > 100) {
            this.imgWidth = this.imgWidth - 10;
        }
        if (this.imgHeight > 100) {
            this.imgHeight = this.imgHeight - 10;
        }
    }
    reSet() {
        this.imgHeight = 100;
        this.imgWidth = 100;
    }
}
